import { render } from "./CustomersSatisfactionReport.vue?vue&type=template&id=48f6ad0c&scoped=true&ts=true"
import script from "./CustomersSatisfactionReport.vue?vue&type=script&lang=ts"
export * from "./CustomersSatisfactionReport.vue?vue&type=script&lang=ts"

import "./CustomersSatisfactionReport.vue?vue&type=style&index=0&id=48f6ad0c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f6ad0c"]])

export default __exports__